import { Model } from '@vuex-orm/core';
import { AxiosResponse } from 'axios';
import AwardImageAPI from '@/api/AwardImageAPI';

export default class AwardImage extends Model {

    public static entity = 'awardImage';

    public static fields() {
        return {
            id: this.string(null),
            position: this.attr(null),
            image: this.string(''),
            uuid: this.string(''),
            title: this.string(''),
            fileSize: this.string(''),
            type: this.string(''),
        };
    }

    public static async createNew(formData: FormData) {
        let awardImage;

        try {
            awardImage = await AwardImageAPI.createNew(formData) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }


        this.insertOrUpdate({
            data: awardImage.data,
        });

        return Promise.resolve(awardImage);
    }

    public static async updateExisting(file: any) {
        let awardImage;

        try {
            awardImage = await AwardImageAPI.updateExisting(file) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: awardImage.data,
        });

        return Promise.resolve(awardImage);
    }

    public id!: string;
    public position!: number;
    public image!: string;
    public uuid!: string;
    public fileSize!: string;
    public title!: string;
    public type!: string;
}
